"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = asyncPromise;
function asyncPromise(promise) {
  return __CLIENT__ ? null : promise;
}
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./src/helpers/async-promise.js
// module id = 43
// module chunks = 1